import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAD = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M14.13 47.52A24.901 24.901 0 0 0 25 50c3.895 0 7.583-.892 10.87-2.48L38.042 25 35.87 2.48A24.9 24.9 0 0 0 25 0 24.9 24.9 0 0 0 14.13 2.48L11.956 25l2.174 22.52Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M35.87 47.518C44.232 43.474 50 34.911 50 25c0-9.912-5.768-18.475-14.13-22.519v45.037Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M14.13 47.518V2.481C5.768 6.525 0 15.088 0 25c0 9.911 5.768 18.474 14.13 22.518Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 33.696V25h6.522v3.26c0 .567-1.087 2.643-3.77 4.349-1.016.646-2.068.854-2.752 1.087ZM18.478 18.479H25V25h-6.522V18.48Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M28.26 16.304A2.174 2.174 0 0 0 25 14.423a2.174 2.174 0 0 0-3.26 1.88h-5.436v10.87c0 4.047 3.214 6.387 5.734 7.6A2.174 2.174 0 0 0 25 37.75a2.174 2.174 0 0 0 2.962-2.977c2.52-1.213 5.734-3.553 5.734-7.6v-10.87H28.26Zm2.175 10.87c0 .566 0 2.29-2.683 3.995-1.016.646-2.068 1.065-2.752 1.298-.684-.233-1.736-.652-2.752-1.298-2.683-1.706-2.683-3.43-2.683-3.996v-7.608h10.87v7.608Z"
}));
FlagAD.displayName = 'FlagAD';
export default withFlagWrapper(FlagAD);
//# sourceMappingURL=index.js.map